// extracted by mini-css-extract-plugin
module.exports = {"closed":"drawer_closed__2ntKm","open":"drawer_open__7JDLs"};